import grooveApi from './groove'

const ENDPOINT_PREFIX = 'email_marketing/integrations'

export const listIntegrations = token =>
  grooveApi.get(token, `${ENDPOINT_PREFIX}`).then(({ json }) => json)

export const getIntegration = (token, id, userId) =>
  grooveApi
    .get(token, `${ENDPOINT_PREFIX}/${id}/subscriptions`, {
      v1_enduser_id: userId,
    })
    .then(({ json }) => json)

export const subscribe = (token, id, userId, list) =>
  grooveApi.post(
    token,
    `${ENDPOINT_PREFIX}/${id}/subscriptions`,
    { v1_enduser_id: userId },
    JSON.stringify({ list_id: list })
  )

export const unsubscribe = (token, id, userId, list) =>
  grooveApi.delete(token, `${ENDPOINT_PREFIX}/${id}/subscriptions/${list}`, {
    v1_enduser_id: userId,
  })
